import React from 'react';
import { Modal } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from 'react-i18next';

function HTMLCKeditor({ show, data, handleClose, handleChange, handleAddData }) {
  const { t } = useTranslation('common');

  return (
    <Modal enforceFocus={false} className="custom-modal modal-large" show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{t('EDIT_TASK_NOTES_MODAL.MODAL_TITLE')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CKEditor
          editor={ClassicEditor}
          data={data}
          config={{
            height: 400,
            toolbar: [
              'lineHeight',
              'heading',
              '|',
              'bold',
              'italic',
              'underline',
              'strikethrough',
              '|',
              'link',
              'bulletedList',
              'numberedList',
              '|',
              'insertTable', // Add "insertTable" button
              '|',
              'undo',
              'redo',
              'pageBreak',
              'alignment',
              '|',
              'fontFamily',
              'fontSize',
              'fontColor',
              'fontBackgroundColor',
              '|',
              'removeFormat',
              'horizontalLine',
              'fullScreen',
            ],
            fontFamily: {
              options: [
                'default',
                'Arial, Helvetica, sans-serif',
                'Courier New, Courier, monospace',
                'Georgia, serif',
                'Lucida Sans, Lucida Grande, Lucida Sans Unicode, sans-serif',
                'Times New Roman, Times, serif',
                'Roboto, sans-serif',
                'Aktiv Grotesk, sans-serif',
                'Aktiv Grotesk, sans-serif',
                'Aktiv Grotesk Medium, sans-serif',
              ],
              supportAllValues: true,
            },
          }}
          onChange={(_event, editor) => {
            const newData = editor.getData();
            handleChange(newData);
          }}
        />
        <div className="modal-buttons mt-5 d-flex justify-content-between">
          <button type="submit" onClick={handleClose} className="btn btn-default">
            {t('EDIT_TASK_NOTES_MODAL.CANCEL_BUTTON')}
          </button>
          <button type="submit" onClick={handleAddData} className="btn btn-default">
            {t('EDIT_TASK_NOTES_MODAL.SAVE_BUTTON')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default HTMLCKeditor;
